/* src/app/content-editor/content-editor.component.scss */
:host {
  display: block;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
  --accent: #0c447c;
  --accent-light: #e6f1fb;
  --bg-secondary: #f7f7f5;
  --bg-page: #fff;
  --text-primary: #1a1a1a;
  --text-secondary: #6b6b6b;
  --text-tertiary: #999;
  --border: rgba(0, 0, 0, 0.1);
  --border-hover: rgba(0, 0, 0, 0.2);
  --row-hover: #fafaf8;
  --purple-bg: #eeedfe;
  --purple-text: #3c3489;
  --teal-bg: #e1f5ee;
  --teal-text: #085041;
  --danger: #c44949;
}
* {
  box-sizing: border-box;
}
.editor-shell {
  display: grid;
  grid-template-columns: 520px 4px minmax(0, 1fr);
  height: 100%;
  background: #fff;
  color: var(--text-primary);
}
.save-error-banner {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 560px;
  padding: 10px 14px;
  border-radius: 6px;
  background: #fdecec;
  border: 1px solid var(--danger);
  color: var(--danger);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  font-size: 13px;
}
.save-error-banner .close {
  margin-left: auto;
  background: none;
  border: none;
  color: var(--danger);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}
.sidebar-resize-handle {
  position: relative;
  width: 4px;
  cursor: col-resize;
  background: var(--border);
  transition: background 0.15s ease;
  z-index: 10;
}
.sidebar-resize-handle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4px;
  height: 32px;
  border-left: 1px solid var(--border-hover);
  border-right: 1px solid var(--border-hover);
  border-radius: 2px;
  transition: border-color 0.15s ease;
}
.sidebar-resize-handle:hover {
  background: rgba(12, 68, 124, 0.15);
}
.sidebar-resize-handle:hover::after {
  border-color: var(--accent);
}
.editor-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: var(--bg-page);
}
.workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-height: 0;
  flex: 1;
  padding: 0 32px 24px;
}
.canvas-stack {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  min-width: 0;
  min-height: 0;
}
.canvas-stack.dual-pane {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.content-canvas {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 0;
  background: transparent;
  overflow: visible;
}
.canvas-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 10px;
  background: transparent;
}
.canvas-kicker {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-tertiary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.canvas-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}
.canvas-body {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 0;
  max-width: 800px;
  background: #fff;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.canvas-body::-webkit-scrollbar {
  width: 8px;
}
.canvas-body::-webkit-scrollbar-track {
  background: transparent;
}
.canvas-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  border: 2px solid #fff;
}
.canvas-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.28);
}
.empty-state {
  padding: 36px 20px;
  border: 1px dashed var(--border);
  border-radius: 14px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 13px;
}
::ng-deep .content-canvas .canvas-body app-tree {
  height: auto;
}
::ng-deep .content-canvas .canvas-body app-tree .tree-node {
  min-height: auto;
}
.append-dropzone {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  padding: 16px;
  border: 2px dashed var(--border);
  border-radius: 12px;
  background: var(--bg-page);
  color: var(--text-tertiary);
  font-size: 13px;
  font-weight: 600;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
}
.append-dropzone.cdk-drop-list-receiving,
.append-dropzone.cdk-drop-list-dragging {
  border-color: var(--accent);
  background: var(--accent-light);
  color: var(--accent);
}
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  margin-bottom: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch .slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccd1d6;
  transition: 0.2s ease;
  border-radius: 999px;
}
.switch .slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  transition: 0.2s ease;
  border-radius: 50%;
}
.switch input:checked + .slider {
  background-color: var(--accent);
}
.switch input:checked + .slider:before {
  transform: translateX(14px);
}
.modal-content {
  background: #fff;
  color: var(--text-primary);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.18);
}
.modal-content .modal-header,
.modal-content .modal-footer {
  border-color: var(--border);
  display: flex;
  justify-content: space-between;
}
.modal-content .modal-body label {
  color: var(--text-secondary);
}
.modal-content .form-control {
  width: 100%;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text-primary);
  padding: 10px 12px;
  font-size: 13px;
  outline: none;
}
.modal-content .form-control:focus {
  border-color: rgba(12, 68, 124, 0.35);
  box-shadow: 0 0 0 4px rgba(12, 68, 124, 0.08);
}
::ng-deep .canvas-body app-tree .tree-node {
  margin-top: 0;
}
::ng-deep .canvas-body app-tree .tree-item-container {
  margin-bottom: 2px;
}
::ng-deep .canvas-body app-tree .tree-item {
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 10px 12px;
  color: var(--text-primary);
  align-items: flex-start;
}
::ng-deep .canvas-body app-tree .tree-item:hover {
  background: var(--row-hover);
}
::ng-deep .canvas-body app-tree .tree-item.deleted {
  background: #fff4f4;
}
::ng-deep .canvas-body app-tree .tree-item.new-item {
  background: #edf8f1;
  color: #2b6e49;
}
::ng-deep .canvas-body app-tree .tree-item.modified-item {
  background: #fffbe7;
  color: #8a5a00;
  border-left: 3px solid #efc14b;
}
::ng-deep .canvas-body app-tree .tree-item.moved-item {
  box-shadow: inset 3px 0 0 0 var(--accent);
}
::ng-deep .canvas-body app-tree .item-tag {
  min-width: 50px;
  border: 0;
  border-radius: 4px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 500;
  text-transform: lowercase;
  text-align: center;
  padding: 1px 8px;
}
::ng-deep .canvas-body app-tree .item-content {
  margin-left: 10px;
  max-width: none;
  flex: 1;
  font-size: 14px;
  line-height: 1.6;
  min-height: 20px;
}
::ng-deep .canvas-body app-tree .item-content a {
  color: blue;
}
::ng-deep .canvas-body app-tree .children-container {
  margin-left: 8px;
  padding-left: 20px;
  border-left: 1px dashed rgba(0, 0, 0, 0.08);
}
::ng-deep .canvas-body app-tree .tree-actions {
  gap: 6px;
}
::ng-deep .canvas-body app-tree .action-icon {
  opacity: 0;
}
::ng-deep .canvas-body app-tree .tree-item:hover .action-icon {
  opacity: 1;
}
::ng-deep .canvas-body app-tree .add-element-btn {
  width: 100%;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: transparent;
  color: var(--text-tertiary);
  padding: 10px;
  font-size: 12px;
  text-align: center;
}
::ng-deep .canvas-body app-tree .add-element-btn:hover {
  background: var(--accent-light);
  border-color: rgba(12, 68, 124, 0.25);
  color: var(--accent);
}
@media (max-width: 960px) {
  .editor-shell {
    grid-template-columns: 1fr;
  }
  .canvas-stack.dual-pane {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=content-editor.component.css.map */
